module.exports = __webpack_public_path__ + "img/can11.4fe6ebed.png";